import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DocumentKeys } from "web_myplann/Api/Document/DocumentKeys";
import { invalidateDocumentListsWhenIdle } from "web_myplann/Api/Document/invalidateDocumentListsWhenIdle";
import { renameDocumentInCache } from "web_myplann/Api/Document/renameDocumentInCache";
import { restoreDocumentListCache } from "web_myplann/Api/Document/restoreDocumentListCache";
import {
	type DocumentEditRequestDTO,
	patchDocumentIdV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

type Props = {
	requestContract: DocumentEditRequestDTO;
	id: number;
	activeTag?: string;
};

export const useDocumentEditMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationKey: DocumentKeys.mutation,
		mutationFn: processResponse(({ requestContract, id }: Props) =>
			patchDocumentIdV2(requestContract, id),
		),
		onMutate: ({ requestContract, id }: Props) =>
			requestContract.title
				? renameDocumentInCache(queryClient, id, requestContract.title)
				: undefined,
		onError: (_error, _variables, snapshot) => {
			if (snapshot) {
				restoreDocumentListCache(queryClient, snapshot);
			}
		},
		onSettled: () => invalidateDocumentListsWhenIdle(queryClient),
	});
};
